<div class="content" mat-dialog-content>
  <p class="content__text">{{ data.message ?? "waitDialog.defaultMessage" | translate }}</p>
  <mat-spinner diameter="30"></mat-spinner>
</div>
